import React, { useEffect, useState } from 'react';
import { BarChart, Package, Users, Ship } from 'lucide-react';
import StatCard from '../components/stats/StatCard';
import { dbOperations } from '../lib/supabase';

const DashboardPage: React.FC = () => {
  const [stats, setStats] = useState({
    activeShipments: 0,
    totalCustomers: 0,
    monthlyRevenue: 0,
    containersInTransit: 0
  });

  useEffect(() => {
    const loadStats = async () => {
      try {
        const shipments = await dbOperations.getShipments();
        
        // Calculate stats from shipments
        const uniqueCustomers = new Set(shipments.map(s => s.customer)).size;
        const totalContainers = shipments.reduce((acc, s) => acc + s.container_count, 0);

        setStats({
          activeShipments: shipments.length,
          totalCustomers: uniqueCustomers,
          monthlyRevenue: shipments.length * 2500, // Simplified calculation
          containersInTransit: totalContainers
        });
      } catch (error) {
        console.error('Error loading dashboard stats:', error);
      }
    };

    loadStats();
  }, []);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <StatCard
          icon={Ship}
          title="Active Shipments"
          value={stats.activeShipments}
          trend={{ value: 12, isPositive: true }}
        />
        <StatCard
          icon={Users}
          title="Active Customers"
          value={stats.totalCustomers}
        />
        <StatCard
          icon={BarChart}
          title="Monthly Revenue"
          value={`$${(stats.monthlyRevenue / 1000).toFixed(1)}K`}
          trend={{ value: 8.1, isPositive: true }}
        />
        <StatCard
          icon={Package}
          title="Containers in Transit"
          value={stats.containersInTransit}
        />
      </div>
    </div>
  );
};

export default DashboardPage;